// extracted by mini-css-extract-plugin
export default {"oops":"Oops_oops__+ZnZ+","logo":"Oops_logo__R3Lm8","message":"Oops_message__Uxh-m","retry":"Oops_retry__giuyU"};